var site = site || {};

site.direction = site.direction || {};

(function ($) {
  var _create_template_id_data_key = function (template_id) {
    return '[data-range-template-id="' + template_id + '"]';
  };
  var _create_filter_key_data_key = function (filter_key) {
    return '[data-shade-filter-' + filter_key + ']';
  };

  Drupal.behaviors.shadeFinderBlock = {
    attach: function (context, settings) {
      var $formatters = $('.js-shade-finder-block', context);

      $formatters.each(function (i, obj) {
        var $formatter = $(obj);
        var $rangeCarouselContainer = $('.js-shade-finder-block-range-carousel', $formatter);
        var $rangeCarousel = $('.js-range-slider-carousel', $formatter);
        var $slider = $rangeCarouselContainer.find("[type='range']");
        var $filters = $('.js-shade-finder-block-filter', $formatter);
        var $filters_menu = $('.js-shade-finder-block-shade-filters', $formatter);
        var prodcat_key = $formatter.data('prodcat-key');
        var $rangeCarouselItems = $('[data-range-template-id]', $formatter);
        var $carousel = $('.js-range-slider-carousel__carousel', $formatter);
        var $widgetItems = $('.range-slider-carousel__widget__item', $formatter);
        // Setup the sku links to use shade routing
        var $skuLinks = $('.js-product-sku-link', $formatter);

        $skuLinks.each(function (i, obj) {
          var $link = $(obj);
          var skuBaseId = $link.data('sku-base-id');

          if (!skuBaseId) {
            return;
          }
          var shadeRouteName = prodcat.ui.generateShadePath(skuBaseId);

          if (!_.isEmpty(shadeRouteName)) {
            obj.hash = shadeRouteName;
          }
        });

        var $nonCarouselItems = [];

        $rangeCarouselItems.each(function (i, obj) {
          if ($(obj).closest('.js-range-slider-carousel__carousel').length > 0) {
            return;
          }
          $nonCarouselItems.push(obj);
        });

        $nonCarouselItems = $($nonCarouselItems);

        // Gather the filter keys
        var filter_keys = {};

        $filters.each(function (i, obj) {
          var $filter = $(obj);
          var filter_key = $filter.data('filter-key');

          if (!_.isEmpty(filter_key)) {
            filter_keys[filter_key] = filter_key;
          }
        });

        var all_sku_filters = {};

        all_sku_filters['all'] = 0;

        // We process the widget items. We assume that widget items are
        // properly setup with a data-sku-id.
        $widgetItems.each(function (i, obj) {
          var $item = $(obj);
          var $sku_card = $('.range-slider-item[data-sku-id]', $item).first();
          var skuId = $sku_card.data('sku-id');
          var skuData = prodcat.data.getSku(skuId);
          var slide_id = $item.data('range-template-id');
          var data_key = _create_template_id_data_key(slide_id);
          // this should include all items that match the widget item
          // *including* the widget item itself
          var $relatedItems = $rangeCarouselItems.filter(data_key);

          // all items have the all filter
          $relatedItems.attr('data-shade-filter-all', 1);

          var filter_value = $sku_card.data('filter-value');

          // if we have no skuData or filter_value. no filter to process
          if (_.isEmpty(skuData) && _.isEmpty(filter_value)) {
            console.log(skuId + ' was empty');

            return;
          }

          // prodcat_key will override. Might need to figure out different
          // logic states.
          if (!_.isEmpty(prodcat_key)) {
            filter_value = skuData[prodcat_key];
          }

          if (_.isEmpty(filter_value)) {
            return;
          }

          // trimed lower case with no spaces
          var filter_arr = filter_value.split(',').map(function (item) {
            return item.trim().toLowerCase().split(' ').join('_');
          });

          _.forEach(filter_arr, function (val) {
            if (!_.has(all_sku_filters, val)) {
              all_sku_filters[val] = 0;
            }
            all_sku_filters[val]++;
            all_sku_filters['all']++;
            // does this match a key?
            if (!_.isEmpty(filter_keys[val])) {
              $relatedItems.attr('data-shade-filter-' + val, 1);
            }
          });
        });

        // mostly for debug so editor/devs can see whats available.
        console.log('shade block filters', all_sku_filters);
        // reprocess the filters and disable ones without any entries
        $filters.each(function (i, obj) {
          var $filter = $(obj);
          var filter_key = $filter.data('filter-key');
          var item_count = 0;

          if (_.has(all_sku_filters, filter_key)) {
            item_count = all_sku_filters[filter_key];
          }
          $filter.attr('data-item-count', item_count);
        });

        $formatter.on('click', '.js-shade-finder-block-filter', function (e) {
          var $filter = $(this);
          var filter_key = $filter.data('filter-key');

          if (_.isEmpty(filter_key)) {
            return;
          }

          var data_key = _create_filter_key_data_key(filter_key);

          $rangeCarousel.trigger('rsc:filter-items', data_key);

          $filters.removeClass('active');
          $filter.addClass('active');
        });

        /*
         * Repond to select slide and update shop now button.
         */
        $rangeCarouselContainer.on('select-slide', function (event, target_slide, sync_slider, sync_carousel, target_slide_id) {
          $formatter.trigger('update-shop-now-button', [target_slide_id]);
        });

        /*
         * Update the shop now button to point to the shade routed url.
         */
        $formatter.on('update-shop-now-button', function (e, target_slide_id) {
          var data_key = _create_template_id_data_key(target_slide_id);
          var $active_widget = $widgetItems.filter(data_key);
          var $active_widget_link = $('.js-shade-finder-link', $active_widget);
          var $shop_now_buttons = $('.js-mantle-cta-button[data-trigger-type="shop_sku"]', $formatter);

          $shop_now_buttons.each(function (i, obj) {
            var $shop_now_link = $(obj);

            $shop_now_link.attr('href', $active_widget_link.attr('href'));
          });
        });

        // menu
        initializeSlick = function ($slider) {
          var unslick_breakpoint = 640;
          var settings = {
            rtl: site.direction.isRTL,
            infinite: false,
            autoplay: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: null,
            nextArrow: null,
            slide: '.js-shade-finder-block-filter',
            rows: 0
          };

          function _slick_slider() {
            if ($(window).width() > unslick_breakpoint) {
              if (MantleCarousel.isCarousel($slider)) {
                MantleCarousel.slick_method($slider, 'unslick');
              }

              return;
            }

            if (!MantleCarousel.isCarousel($slider)) {
              return $slider.slick(settings);
            }
          }
          $(window).on('resize', _.debounce(_slick_slider, 100));
          _slick_slider();
        };

        // using regular css for now.
        // initializeSlick($filters_menu);;

        // default shop now to first
        $formatter.trigger('update-shop-now-button', 0);
        // default to first fitler being active
        $filters.first().addClass('active');
      });
    }
  };
})(jQuery);
